import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface Tomo {
  title: string;
  subtopics: string[];
}
const tomos: Tomo[] = [{
  title: 'FUNDAMENTOS DEL JUGADOR',
  subtopics: ['Introducción', 'Problema del jugador promedio', 'Demandas del hockey moderno', 'Capacidades clave', 'Mentalidad competitiva', 'Evaluación inicial', 'Errores comunes']
}, {
  title: 'TÉCNICA INDIVIDUAL',
  subtopics: ['Control de bocha', 'Conducción', 'Eliminaciones', 'Recepción', 'Pase', 'Definición', 'Automatización técnica']
}, {
  title: 'PREPARACIÓN FÍSICA',
  subtopics: ['Bases físicas', 'Fuerza', 'Potencia', 'Cambios de dirección', 'Pliometría', 'Resistencia específica', 'Prevención de lesiones']
}, {
  title: 'VELOCIDAD Y AGILIDAD',
  subtopics: ['Tipos de velocidad', 'Aceleración', 'Frenadas', 'Trabajo lateral', 'Reacción', 'Circuitos']
}, {
  title: 'TÁCTICA',
  subtopics: ['Lectura de juego', 'Posicionamiento', 'Juego sin bocha', 'Transiciones', 'Presión', 'Situaciones reales']
}, {
  title: 'SISTEMA COMPLETO',
  subtopics: ['Cómo planificar', 'Estructura de sesión', 'Circuitos', 'Plan semanal', 'Plan mensual', 'Pretemporada', 'Temporada']
}];
export function ContentSection() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const toggleExpand = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-23">
      <div className="text-center mb-16" data-id="element-24">
        <h2 className="font-heading text-4xl md:text-5xl font-bold mb-6 text-[#faf5e8]" data-id="element-25">
          Contenido del Sistema
        </h2>
        <p className="text-xl md:text-2xl text-[#a8c5a8]" data-id="element-26">
          6 Tomos completos con todo lo que necesitás para dominar tu juego
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-27">
        {tomos.map((tomo, index) => <div key={index} className="bg-[#223322] rounded-xl border border-green-800/50 hover:border-[#c8e6c9]/40 transition-all overflow-hidden" data-id="element-28">
            <button onClick={() => toggleExpand(index)} className="w-full flex items-center p-6 text-left group" data-id="element-29">
              <div className="flex-shrink-0 w-12 h-12 bg-green-900/40 rounded-full flex items-center justify-center mr-5 group-hover:bg-green-800/50 transition-colors" data-id="element-30">
                <span className="text-[#c8e6c9] font-bold text-xl" data-id="element-31">
                  {index + 1}
                </span>
              </div>
              <div className="flex-1" data-id="element-32">
                <p className="text-sm text-[#c8e6c9] font-bold uppercase tracking-wider" data-id="element-33">
                  🔹 Tomo {index + 1}
                </p>
                <h3 className="font-heading text-lg font-bold text-[#faf5e8]" data-id="element-34">
                  {tomo.title}
                </h3>
              </div>
              <div className="flex-shrink-0 ml-4 text-[#a8c5a8]" data-id="element-35">
                {expandedIndex === index ? <ChevronUp className="w-5 h-5" data-id="element-36" /> : <ChevronDown className="w-5 h-5" data-id="element-37" />}
              </div>
            </button>

            {expandedIndex === index && <div className="px-6 pb-6 pt-0" data-id="element-38">
                <div className="border-t border-green-800/40 pt-4 ml-17" data-id="element-39">
                  <ul className="space-y-2 ml-[68px]" data-id="element-40">
                    {tomo.subtopics.map((topic, i) => <li key={i} className="flex items-center gap-2 text-[#c8d8c8]" data-id="element-41">
                        <span className="w-1.5 h-1.5 bg-[#c8e6c9] rounded-full flex-shrink-0" data-id="element-42" />
                        {topic}
                      </li>)}
                  </ul>
                </div>
              </div>}
          </div>)}
      </div>
    </section>;
}